import { render } from "./App.vue?vue&type=template&id=5fabaf9c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5fabaf9c&lang=scss"

import exportComponent from "/home/todo/todo/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__